import { ProductPageEntity } from "~/interfaces/entities/ProductPage"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: productPages,
  selectors: productPagesSelectors,
} = createEntitySlice<ProductPageEntity>("productPages")
